import { render } from "./NotAllowed.vue?vue&type=template&id=2e0be3df"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__